module.exports = window["MaterialUI"].MuiThemeProvider;